import React from "react";
import styled from "styled-components";
import {Page,TitleWithHorizontalLine, FlexContainer,ScrollableContainer, AnimatedList } from "../components/styled";
import TokenCard from "../components/tokenCard";
// import SwipeableTabs from "../components/shared/swipeableTabs";
import ProfileCard from "../components/profileCard";
import { useEffect ,useState} from "react";
import { useUserContext } from "../context/UserContext";
import { getTokens,getNovaPrice } from "../service/main/api";
 import NovaImage from "../assets/images/logo/tokens/nova.png";
 import PendingIcon from "../assets/images/pending.png";
import TickImage from "../assets/icons/tick.png"
import CloseImgae from "../assets/icons/close.png"
import NoDataImage from "../assets/images/noData.png";
import CustomSelect from "../components/shared/customSelect";
import { getWithdrawOrders } from "../service/main/api";
// import TonImage from "../assets/images/logo/tokens/ton.png";
// import PresaleImage from "../assets/images/presale.png";
// import PublicSaleImage from "../assets/images/publicsale.jpg";
// import DiscountImage from "../assets/images/discount.png";
// import GiftImage from "../assets/images/gift.png";
import withdrawImage from "../assets/images/withdraw.png";
import {useLoading} from "../context/LoadingContext";


const Wallet = () => {
  const { user } = useUserContext();
  const [tokenList, setTokenList] = useState([]);
  const [showUnprocessed, setShowUnprocessed] = useState(false);
  const [novaPrice, setNovaPrice] = useState(0);
  const [withdrawals, setWithdrawals] = useState([]);
  const {setIsLoading} = useLoading();
  const prepareTokens = async () => {
    const res= await getTokens();
    if(res.success){
      const tokens = res.data;
      let list = [];
      tokens.forEach((token) => {
          let tokenData = {
              id: token._id,
              name: token.name,
              balance: (user.balances[token._id]) || 0,
              logo: require(`../assets/images/logo/tokens/${(token.symbol).toLowerCase()}.png`),
              symbol: token.symbol,
              balanceUSD:((user.balances[token._id]) || 0) * novaPrice,
              price:novaPrice,
          };
          list.push(tokenData);
      });
      setTokenList(list);
      // setTimeout(async () => {
      //   await prepareTransactions();
      // }, 2000);
     
    }

  };
  const fetchWithdrawals = async () => {
    setIsLoading(true);
    const res = await getWithdrawOrders();
    if(res.success){
      let data = res.data;
      if(!showUnprocessed){
        data = data.filter(t => t.status !== "unprocessed");
      }
      setWithdrawals(data);
    }
    setIsLoading(false);
  }
  useEffect(() => {
    fetchWithdrawals();
  },[showUnprocessed]);
  useEffect(() => {
    if(!user || novaPrice === 0) return;
    prepareTokens();   
  },[user,novaPrice]);
  const fetchNovaPrice = async () => {
    const res = await getNovaPrice();
    if(res?.success){
        setNovaPrice(Number(res.data));
    }
}
useEffect(() => {
    fetchNovaPrice();
}, []);
  // useEffect(() => {
  //   prepareTransactions();
  // },
  // [showUnprocessed]);
  return (
    <Page style={{paddingInline:0}}>
      <ScrollableContainer style={{paddingInline:16}}>
      <ProfileCard />
      <FlexContainer
        flexdirection="column"
        gap="16px"
        style={{ marginTop: "64px" }}
      >
        <TitleWithHorizontalLine>Tokens</TitleWithHorizontalLine>
        <CardContent>
          {React.Children.toArray(
            tokenList.map((token,i) => <AnimatedList style={{animationDelay:`${i * .2}s`, width:"100%"}}><TokenCard {...token} /></AnimatedList>)
          )}
        </CardContent>
      </FlexContainer>
      <FlexContainer
        flexdirection="column"
        gap="16px"
        style={{ marginTop: "32px"}}
      >
        <TitleWithHorizontalLine style={{fontSize:18}}>Withdraw History</TitleWithHorizontalLine>
           <ScrollableContainer style={{paddingTop:"60px",position:"relative",height:"50vh",paddingBottom:"34px"}}>
           <FilterTab>
                <CustomSelect
                    options={[
                        {label:"Hide Unprocessed",value:false},
                        {label:"Show All",value:true}
                    ]}
                    value={showUnprocessed}
                    onChange={(value)=>setShowUnprocessed(value)}
                />
                <RefreshButton onClick={fetchWithdrawals}>Refresh</RefreshButton>
            </FilterTab>
            <TransactionList>
                    {withdrawals.length === 0 ?
                    <FlexContainer style={{height:"100%",justifyContent:"center",alignItems:"center",flexDirection:"column"}}>
                    <img src={NoDataImage} alt="no data"/>
                    </FlexContainer>
                    :
                    React.Children.toArray(withdrawals.map((t, i) => (
                      <AnimatedList style={{animationDelay:`${i * .2}s`, width:"100%"}}>
                         <TransactionItemContainer>
                            <LeftContainer>
                            <StyledImage src={withdrawImage} alt="withdraw"/>
                            <FlexContainer flexdirection="column">
                                 
                                <StyledText>Tx Hash: <strong>{t.txHash || "N/A"}</strong></StyledText>
                                <StyledText>Withdraw:<img style={{width:"18px"}} src={NovaImage} alt="nova"/> {t.pointsBurned.toLocaleString('en-CA')} <strong> Nova</strong></StyledText>
                                <StyledText>Date:<strong>{new Date(t.updatedAt).toLocaleString('en-GB',{timeZone:"UTC"})}</strong></StyledText>
                            </FlexContainer>
                            </LeftContainer>
                            <StatusContainer>
                                <img src={t.status === "pending" ? PendingIcon : t.status === "success" ? TickImage : CloseImgae} alt="status"/>
                                <span>{t.status}</span>
                                <span>{new Date(t.createdAt).toLocaleDateString('en-CA')}</span>
                            </StatusContainer>
                        </TransactionItemContainer> 
                        </AnimatedList>
                    )))}
            </TransactionList>
         </ScrollableContainer>
        {/* <SwipeableTabs tabs={["Presale", "Withdraw","Publicsale","Airdrop"]} >
           <ScrollableContainer style={{paddingTop:"60px",position:"relative",height:"50vh",paddingBottom:"34px"}}>
           <FilterTab>
                <CustomSelect
                    options={[
                        {label:"Hide Unprocessed",value:false},
                        {label:"Show All",value:true}
                    ]}
                    value={showUnprocessed}
                    onChange={(value)=>setShowUnprocessed(value)}
                />
            </FilterTab>
            <TransactionList>
                    {presales.length === 0 ?
                    <FlexContainer style={{height:"100%",justifyContent:"center",alignItems:"center",flexDirection:"column"}}>
                    <img src={NoDataImage} alt="no data"/>
                    </FlexContainer>
                    :
                    React.Children.toArray(presales.map((t,i ) => (
                      <AnimatedList style={{animationDelay:`${i * .2}s`, width:"100%"}}>
                        <TransactionItemContainer>
                            <LeftContainer>
                            <StyledImage src={PresaleImage} alt="pack"/>
                            <FlexContainer flexdirection="column">
                                 {t.token?.name && <StyledText><img style={{width:"18px"}} src={t.token?.logo}/><strong>{t.token?.symbol}</strong></StyledText>}
                                <StyledText>invoiceId: <strong>{t.invoiceId}</strong></StyledText>
                                {<StyledText>Payment:<img style={{width:"18px"}} src={TonImage} alt="ton"/>  <strong>{t.amount} Ton</strong>
                                  
                                </StyledText>}
                            </FlexContainer>
                            </LeftContainer>
                            <StatusContainer>
                                <img src={t.status === "pending" ? PendingIcon : t.status === "success" ? TickImage : CloseImgae} alt="status"/>
                                <span>{t.status}</span>
                                <span>{new Date(t.date).toLocaleDateString('en-CA')}</span>
                            </StatusContainer>
                        </TransactionItemContainer>
                        </AnimatedList>
                    )))}
            </TransactionList>
           </ScrollableContainer>
           <ScrollableContainer style={{paddingTop:"60px",position:"relative",height:"50vh",paddingBottom:"34px"}}>
           <FilterTab>
                <CustomSelect
                    options={[
                        {label:"Hide Unprocessed",value:false},
                        {label:"Show All",value:true}
                    ]}
                    value={showUnprocessed}
                    onChange={(value)=>setShowUnprocessed(value)}
                />
            </FilterTab>
            <TransactionList>
                    {withdrawals.length === 0 ?
                    <FlexContainer style={{height:"100%",justifyContent:"center",alignItems:"center",flexDirection:"column"}}>
                    <img src={NoDataImage} alt="no data"/>
                    </FlexContainer>
                    :
                    React.Children.toArray(withdrawals.map((t, i) => (
                      <AnimatedList style={{animationDelay:`${i * .2}s`, width:"100%"}}>
                        <TransactionItemContainer>
                            <LeftContainer>
                            <StyledImage src={withdrawImage} alt="withdraw"/>
                            <FlexContainer flexdirection="column">
                                 
                                <StyledText>invoiceId: <strong>{t.invoiceId}</strong></StyledText>
                                {t.tokenImage &&<StyledText>Withdraw:<img style={{width:"18px"}} src={t.tokenImage} alt={t.token?.symbol}/>  <strong>{t.amount} {t.token?.symbol}</strong></StyledText>}
                                <StyledText>Date:<strong>{new Date(t.date).toLocaleString('en-GB',{timeZone:"UTC"})}</strong></StyledText>
                            </FlexContainer>
                            </LeftContainer>
                            <StatusContainer>
                                <img src={t.status === "pending" ? PendingIcon : t.status === "success" ? TickImage : CloseImgae} alt="status"/>
                                <span>{t.status}</span>
                                <span>{new Date(t.date).toLocaleDateString('en-CA')}</span>
                            </StatusContainer>
                        </TransactionItemContainer>
                        </AnimatedList>
                    )))}
            </TransactionList>
           </ScrollableContainer>
           <ScrollableContainer style={{paddingTop:"60px",position:"relative",height:"50vh",paddingBottom:"34px"}}>
           <FilterTab>
                <CustomSelect
                    options={[
                        {label:"Hide Unprocessed",value:false},
                        {label:"Show All",value:true}
                    ]}
                    value={showUnprocessed}
                    onChange={(value)=>setShowUnprocessed(value)}
                />
            </FilterTab>
            <TransactionList>
                    {publicSales.length === 0 ?
                    <FlexContainer style={{height:"100%",justifyContent:"center",alignItems:"center",flexDirection:"column"}}>
                    <img src={NoDataImage} alt="no data"/>
                    </FlexContainer>
                    :
                    React.Children.toArray(publicSales.map((t,i) => (
                        <AnimatedList style={{animationDelay:`${i * .2}s`, width:"100%"}}>
                          <TransactionItemContainer>
                            <LeftContainer>
                            <StyledImage src={DiscountImage} alt="pack"/>
                            <FlexContainer flexdirection="column">
                                 {t.tokenImage && <StyledText><img style={{width:"18px"}} src={t.tokenImage}/><strong>{t.token?.symbol}</strong></StyledText>}
                                <StyledText>invoiceId: <strong>{t.invoiceId}</strong></StyledText>
                                {<StyledText>Payment:<img style={{width:"18px"}} src={NovaImage} alt="ton"/>  <strong>{t.amount} Nova</strong>
                                  
                                </StyledText>}
                            </FlexContainer>
                            </LeftContainer>
                            <StatusContainer>
                                <img src={t.status === "pending" ? PendingIcon : t.status === "success" ? TickImage : CloseImgae} alt="status"/>
                                <span>{t.status}</span>
                                <span>{new Date(t.date).toLocaleDateString('en-CA')}</span>
                            </StatusContainer>
                        </TransactionItemContainer>
                        </AnimatedList>
                    )))}
            </TransactionList>
           </ScrollableContainer>
           <ScrollableContainer style={{paddingTop:"60px",position:"relative",height:"50vh",paddingBottom:"34px"}}>
           <FilterTab>
                <CustomSelect
                    options={[
                        {label:"Hide Unprocessed",value:false},
                        {label:"Show All",value:true}
                    ]}
                    value={showUnprocessed}
                    onChange={(value)=>setShowUnprocessed(value)}
                />
            </FilterTab>
            <TransactionList>
                    {airdrops.length === 0 ?
                    <FlexContainer style={{height:"100%",justifyContent:"center",alignItems:"center",flexDirection:"column"}}>
                    <img src={NoDataImage} alt="no data"/>
                    </FlexContainer>
                    :
                    React.Children.toArray(airdrops.map((t,i) => (
                      <AnimatedList style={{animationDelay:`${i * .2}s`, width:"100%"}}>
                        <TransactionItemContainer>
                            <LeftContainer>
                            <StyledImage style={{width:"44px"}} src={GiftImage} alt="pack"/>
                            <FlexContainer flexdirection="column">
                            {<StyledText>Airdrop:<img style={{width:"18px"}} src={NovaImage} alt="ton"/>  <strong>{t.amount} Nova</strong></StyledText>}
                            <StyledText>invoiceId: <strong>{t.invoiceId}</strong></StyledText>
                                
                            </FlexContainer>
                            </LeftContainer>
                            <StatusContainer>
                                <img src={t.status === "pending" ? PendingIcon : t.status === "success" ? TickImage : CloseImgae} alt="status"/>
                                <span>{t.status}</span>
                                <span>{new Date(t.date).toLocaleDateString('en-CA')}</span>
                            </StatusContainer>
                        </TransactionItemContainer>
                        </AnimatedList>
                    )))}
            </TransactionList>
           </ScrollableContainer>
        </SwipeableTabs> */}
      </FlexContainer>
      </ScrollableContainer>
    </Page>
  );
};
const CardContent = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;
const FilterTab = styled.div`
    display:flex;
    justify-content:space-between;
    align-items:center;
    gap:8px;
    padding:8px;
    border-radius: 12px;
    background-color:rgba(65, 65, 66, 0.18);
    backdrop-filter: blur(52.70000076293945px);
    -webkit-backdrop-filter: blur(52.70000076293945px);
    height: 48px;
    width: 100%;
    border-radius: 12px;
    margin-bottom: 8px;
    position: absolute;
    top:8px;
    z-index: 1;
`
const TransactionList = styled(FlexContainer)`
    gap: 8px;
    flex-direction: column;
    padding: 8px;
`;
const TransactionItemContainer = styled(FlexContainer)`
    height:84px;
    border: 1px solid #7455BF;
    backdrop-filter: blur(52.70000076293945px);
    -webkit-backdrop-filter: blur(52.70000076293945px);
    border-radius:18px;
    padding:0 16px;
    justify-content:space-between;
    gap:8px;
`;
const StatusContainer = styled.div`
    display:flex;
    align-items:center;
    flex-direction:column;
    gap:8px;
    width: 84px;
    img{
        width:24px;
        height:24px;
    }
    span{
        font-size:0.8em;
        color:#FFFFFF;
        opacity:0.7;
        text-transform:uppercase;
    }
`;
const StyledImage = styled.img`
    width: auto;
    max-width: 42px;
    height: auto;
`;
const LeftContainer = styled.div`
    display:flex;
    align-items:center;
    justify-content:center;
    gap:8px;
    height:100%;
    ${FlexContainer}{
        justify-content:flex-start;
        align-items:flex-start;
        gap:4px;
    }
`;
const StyledText = styled.span`
    color:#fffafac2;
    font-size:10px;
    font-weight: 400;
    /* opacity:0.7; */
    display:flex;
    align-items:center;
    gap:4px;
`;
const RefreshButton = styled.button`
    padding: 8px 16px;
    border-radius: 8px;
    background-color: #7455bf;
    color: #fff;
    font-size: 10px;
    font-weight: 600;
    border: none;
    cursor: pointer;
    
`;
export default Wallet;
